import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from 'reselect';

const ProfileDropdown = () => {

    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user.user
      );
    // Inside your component
    const user = useSelector(profiledropdownData);

    const [userName, setUserName] = useState("Admin");
    const [userRole, setUserRole] = useState("Founder");

    useEffect(() => {
        if (sessionStorage.getItem("authUser")) {
            const obj = JSON.parse(sessionStorage.getItem("authUser"));
            
            // Check if this is backend API response
            const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
            const useBackend = process.env.REACT_APP_DEFAULTAUTH === "backend" || 
                               !!process.env.REACT_APP_API_URL || 
                               apiUrl.includes("localhost:3000");
            
            if (useBackend && obj) {
                // Backend API response structure - check both obj.user and obj directly
                // since the API response might be stored at root level or in user property
                const userData = obj.user || obj;
                
                // Construct full name from firstName and lastName only (no middleName)
                if (userData.firstName || userData.lastName) {
                    const nameParts = [
                        userData.firstName,
                        userData.lastName
                    ].filter(Boolean); // Remove empty parts
                    setUserName(nameParts.join(" ") || userData.username || userData.email || "Admin");
                } else if (userData.username) {
                    setUserName(userData.username);
                } else if (userData.email) {
                    setUserName(userData.email);
                } else {
                    setUserName("Admin");
                }
                
                // Get role name from stored role object (set during login)
                if (obj.role && obj.role.roleName) {
                    setUserRole(obj.role.roleName);
                } else if (userData.roleID && userData.roleID.roleName) {
                    setUserRole(userData.roleID.roleName);
                } else if (userData.role && typeof userData.role === 'string') {
                    setUserRole(userData.role);
                } else if (userData.role && userData.role.roleName) {
                    setUserRole(userData.role.roleName);
                } else {
                    setUserRole("User");
                }
            } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
                // Fake backend logic
                setUserName(obj.username === undefined ? user.first_name ? user.first_name : obj.data?.first_name : "Admin" || "Admin");
            } else if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
                // Firebase logic
                setUserName(obj.email && obj.email || "Admin");
            }
        }
    }, [userName, user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{userRole}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem href= "/settings-profile-settings"><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Profile</span></DropdownItem>
                    <DropdownItem href= "/logout"><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;